import Modal from "react-bootstrap/Modal";
import React, { useState, useContext } from "react";
import searchicon from "../../../assets/images/ic_search.svg";
import importicon from "../../../assets/images/ic_export1.svg";
import excel from "../../../assets/images/ic_excel.svg";
import filterIcon from "../../../assets/images/ic_filter.svg";
import Dropdown from "react-bootstrap/Dropdown";
import Up_arrow_white from "../../../assets/images/Up_arrow_white.svg";
import downarrow from "../../../assets/images/downarrowlist.svg";
import optionIcon from "../../../assets/images/optionDot.svg";
import { AppContext } from "../../../context/AppContext";
import Moment from "react-moment";
import { BeatLoader } from "react-spinners";
import ReportTabs from "../../../sharedComponent/ReportTabs";
import DarkCross from "../../../assets/images/close_modal.svg";
import LightCross from "../../../assets/images/close_modal_dark.svg";
import ReactPaginate from "react-paginate";
import NoDataFound from "../../ChatAdmin/NodataFound";
import ApiConfig from "../../../api/ApiConfig";
import ServiceinvoiceView from "../../../component/Sales/ServiceinvoiceView";
import ServicePrintPreview from "../../../component/Sales/ServicePrintPreview";
import FileSaver from "file-saver";
import {
  PostCallWithAuthToken,
  postMultipartWithAuthCallWithErrorResponse,
} from "../../../api/ApiServices";

import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isBetween);
dayjs.extend(isoWeek);

const PurchaseReport = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [innermenu, setinnermenu] = useState(false);
  const [innermenu2, setinnermenu2] = useState(false);
  const [date, setDate] = useState(false);
  const [company, setCompany] = useState(false);
  const [option, setOption] = useState(false);
  const { sidebar, Dark, get, appSettings } = useContext(AppContext);
  const [purchaseReport, setPurchaseReport] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUsersPerPage] = useState(5);
  const [reportPayLoad, setReportPayLoad] = useState({
    payMode: "All",
  });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [active] = useState("");

  const innerlist = () => {
    setinnermenu(!innermenu);
    setinnermenu2(false);
  };
  const chnagviwe = () => {
    setinnermenu2(!innermenu2);
    setinnermenu(false);
  };
  const handeldate = () => {
    setDate(true);
  };
  const dateclose = () => {
    setDate(false);
  };
  const compantShow = () => {
    setCompany(true);
  };
  const companyClose = () => {
    setCompany(false);
  };
  const optionshow = () => {
    setOption(!option);
  };

  const toggleMenu = () => {
    setinnermenu2(!innermenu2);
  };
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/"); // Split into day, month, and year
    return `${year}-${month}-${day}`; // Return the ISO format (YYYY-MM-DD)
  };

  const getDateRange = (viewType) => {
    let fromDate;
    let toDate;

    switch (viewType) {
      case "Daily":
        const today = dayjs();
        const startOfToday = today.startOf("day");
        const endOfToday = today.endOf("day");
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: startOfToday,
          toDate: endOfToday,
        });
        break;

      case "Weekly":
        const today2 = dayjs();
        const toDate2 = today2.endOf("day");
        const fromDate2 = today2.subtract(6, "day").startOf("day");
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: fromDate2,
          toDate: toDate2,
        });
        break;

      case "Quarterly":
        const currentDate2 = dayjs();
        const fromDate4 = currentDate2.subtract(4, "month");
        const toDate4 = currentDate2.endOf("day");

        setReportPayLoad({
          ...reportPayLoad,
          fromDate: fromDate4,
          toDate: toDate4,
        });
        break;

      case "Semi-Annually":
        const currentDate = dayjs();
        const fromDate = currentDate.subtract(6, "month");
        const toDate = currentDate.endOf("day");

        setReportPayLoad({
          ...reportPayLoad,
          fromDate,
          toDate,
        });
        break;

      case "Annually":
        const today3 = dayjs();
        const fromDate3 = today3.subtract(1, "year");
        const toDate3 = today3;
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: fromDate3,
          toDate: toDate3,
        });
        break;

      default:
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: null,
          toDate: null,
        });
        break;
    }

    return { fromDate, toDate };
  };

  const startIndex = currentPage * usersPerPage;
  const endIndex = startIndex + parseInt(usersPerPage);

  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };

  const pageSizeHandler = (e) => {
    setUsersPerPage(e.target.value);
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(purchaseReport?.length / usersPerPage);

  const searchedDataPageCounts =
    purchaseReport &&
    purchaseReport.length &&
    purchaseReport.filter((item) =>
      item.particular?.toLowerCase().includes(searchValue)
    );

  const [previewTaxInvoiceData, setPreviewTaxInvoiceData] = useState({});
  const [previewLoader, setPreviewLoader] = useState(false);
  const [isView, setIsView] = useState(false);
  const [print, setPrint] = useState(false);
  const [printModal, setPrintModal] = useState(false);

  const getTaxInvoiceData = (invoiceId, actionType) => {
    get(ApiConfig.GET_PURCHASE_INVOICE_TAX_DATA + `/${invoiceId}`)
      .then((res) => {
        setPreviewTaxInvoiceData(res.data);
        if (actionType?.includes("view")) {
          setIsView(true);
        } else if (actionType?.includes("print")) {
          setPrint(true);
        }
      })
      .catch((err) => console.log(err));
  };

  const displayInvoices =
    purchaseReport &&
    purchaseReport.slice(startIndex, endIndex).map((report, index) => {
      return (
        <tr className="table-row-custom salesList">
          <td>{startIndex + index + 1}</td>
          <td>
            <Moment format="DD/MM/YYYY">{report.invoiceDate}</Moment>
          </td>

          <td>{report.particular}</td>
          <td>{report.invoiceType}</td>
          <td>{report.invoiceNo}</td>
          {appSettings && appSettings.isGSTApplicable && (
            <td>{report.eWayBill}</td>
          )}

          <td>₹{report.basicAmt}</td>
          {appSettings && appSettings.isGSTApplicable && <td>₹{report.cgst}</td>}

          {appSettings && appSettings.isGSTApplicable && <td>₹{report.sgst}</td>}
          {appSettings && appSettings.isGSTApplicable && <td>₹{report.igst}</td>}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.amount}</td>
          )}

          <td>₹{report.grossTotal}</td>
          <td>₹{report.otherCharges}</td>
          <td>
            <Dropdown className="DropdownMenoReport ">
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="threedotOption "
              >
                <img src={optionIcon} alt="" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdownMeno22">
                <ul className="dropdownmenulist22">
                  <li
                    onClick={() => {
                      getTaxInvoiceData(report?.id, "print");
                    }}
                  >
                    Print
                  </li>
                  <li
                    onClick={() => {
                      // optionshow();
                      getTaxInvoiceData(report?.id, "view");
                    }}
                  >
                    View
                  </li>
                  <li>Download</li>
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          </td>
        </tr>
      );
    });

  const displayInvoicesSearch =
    purchaseReport &&
    purchaseReport
      ?.filter(
        (item) =>
          item.particular &&
          (item.particular.toUpperCase().includes(searchValue.toUpperCase()) ||
            item.particular.toLowerCase().includes(searchValue.toLowerCase()))
      )
      .slice(startIndex, endIndex)
      .map((report, index) => {
        return (
          <tr className="table-row-custom salesList">
            <td>{startIndex + index + 1}</td>
            <td>
              <Moment format="DD/MM/YYYY">{report.invoiceDate}</Moment>
            </td>

            <td>{report.particular}</td>
            <td>{report.invoiceType}</td>
            <td>{report.invoiceNo}</td>
            {appSettings && appSettings.isGSTApplicable && (
              <td>{report.eWayBill}</td>
            )}

            <td>₹{report.basicAmt}</td>
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.cgst}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.sgst}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igst}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.amount}</td>
            )}

            <td>₹{report.grossTotal}</td>
            <td>₹{report.otherCharges}</td>
            <td>
              <Dropdown className="DropdownMenoReport ">
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  className="threedotOption "
                >
                  <img src={optionIcon} alt="" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdownMeno22">
                  <ul className="dropdownmenulist22">
                    <li onClick={() => optionshow()}>View</li>
                    <li>Download</li>
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </td>
          </tr>
        );
      });

  const exportpurchaseReport = () => {
    // setLoading(true);
    PostCallWithAuthToken(
      ApiConfig.DOWNLOAD_EXCEL_PURCHASE_REPORT,
      JSON.stringify(reportPayLoad)
    )
      .then((res) => {
        console.log(res.json.excelBase64);

        const byteCharacters = atob(res.json.excelBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Save the Blob as a file
        FileSaver.saveAs(blob, "PurchaseReport.xlsx");
        // if(res && res.success){
        // FileSaver.saveAs(
        // "data:" + res.excelBase64 + ";base64," + "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // "Sales Goods List"
        // );
        // notifySuccess("Excel sheet download successfully");

        //setSalesReport();
        //setLoading();
      })
      .catch((err) => console.log("Catch error from downLoadExcelFile,", err));
  };

  return (
    <div>
      {/* <Header />
            <Sidebar /> */}
      <div
        id="cx-main"
        className={sidebar ? "SalesGoods-main" : "cx-active SalesGoods-main"}
      >
        <div className="role-content">
          <ReportTabs
            setPurchaseReport={setPurchaseReport}
            reportPayLoad={reportPayLoad}
            setReportPayLoad={setReportPayLoad}
            setLoading={setLoading}
          />
          <div className="d-flex justify-content-between role-searchbar-and-btns">
            <div className="role-table-header">
              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Search"
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setCurrentPage(0);
                    setUsersPerPage(5);
                  }}
                />
                <img src={searchicon} alt="" />
              </div>
              <div className="entries-wrapper">
                <p className="colorlightmode">Entries per page</p>
                <select
                  className="form-select select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => pageSizeHandler(e)}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                </select>
              </div>
            </div>

            <div className="role-btns-wrapper">
              {/* <button onClick={handleShow}>
                <img src={importicon} alt="" />
              </button> */}
              <button onClick={exportpurchaseReport}>
                {" "}
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5901 17.2281C12.5721 17.2294 12.5541 17.2294 12.5361 17.2281L3.02012 15.8691C2.84089 15.8433 2.67681 15.7542 2.55758 15.6179C2.43835 15.4816 2.37185 15.3072 2.37012 15.1261V2.86911C2.37111 2.68741 2.43725 2.5121 2.55653 2.37502C2.6758 2.23794 2.8403 2.14821 3.02012 2.12211L12.5351 0.769115C12.5885 0.761859 12.6428 0.765946 12.6945 0.78111C12.7462 0.796274 12.7941 0.822173 12.8351 0.857115C12.8759 0.892567 12.9086 0.936351 12.931 0.985515C12.9535 1.03468 12.9651 1.08808 12.9651 1.14211V16.8511C12.9646 16.9508 12.9247 17.0463 12.8541 17.1168C12.7834 17.1872 12.6879 17.2269 12.5881 17.2271L12.5901 17.2281ZM7.40912 10.4801L8.42012 12.2801H9.93912L8.17012 9.13111L9.93912 5.98511H8.42112L7.40912 7.78511L6.39712 5.98511H4.87812L6.64912 9.13111L4.87812 12.2771H6.39712L7.40812 10.4771L7.40912 10.4801ZM16.7521 15.7801H13.7241V14.2691H15.9941V3.72411H13.7241V2.21811H16.7511C16.9513 2.21785 17.1434 2.29697 17.2853 2.43813C17.4272 2.57928 17.5073 2.77096 17.5081 2.97111V15.0251C17.5076 15.2253 17.4277 15.417 17.286 15.5584C17.1443 15.6997 16.9523 15.7791 16.7521 15.7791V15.7801Z"
                    fill="#3DA298"
                  />
                </svg>
              </button>
              <Dropdown className="DropdownMenoReport">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  {/* <img src={filterIcon} alt="" /> */}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 11H17V13H7V11ZM4 7H20V9H4V7ZM10 15H14V17H10V15Z"
                      fill="#3DA298"
                    />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className={
                    Dark === "darkMode" ? "dropdownMeno" : "dropdownMeno2"
                  }
                >
                  <img src={Up_arrow_white} alt="" className="up-img-sales" />
                  <Dropdown.ItemText>
                    <div className="topsectionReport">
                      <div className="filtermenu">Filter</div>
                      <div className="filterline"></div>
                    </div>
                  </Dropdown.ItemText>
                  <ul className="dropdownmenulist lightdropdown22">
                    <li onClick={() => handeldate()}>By Date</li>
                    {/* <li onClick={() => compantShow()}>By Company</li> */}
                    <li
                      onClick={() => {
                        innerlist();
                      }}
                      // className="changeViweToggle"
                      className={active}
                    >
                      <label>Display Item</label>
                      <img src={downarrow} alt="" />
                    </li>
                    {innermenu == true ? (
                      <ul className="dropdownmenulist ">
                        <li className="innerlistrpt option-btns">
                          <input
                            type="radio"
                            id="radio1"
                            className="form-check-input"
                          />
                          <label for="radio1" className="form-check-label">
                            GST
                          </label>
                        </li>
                        <li className="innerlistrpt">
                          <input type="radio" id="radio2" />
                          <label for="radio2">Invoice Type</label>
                        </li>
                        <li className="innerlistrpt">
                          <input type="radio" id="radio3" />
                          <label for="radio3">Gross Total</label>
                        </li>
                        <li className="innerlistrpt">
                          <input type="radio" id="radio4" />
                          <label for="radio4">Other Charges</label>
                        </li>
                      </ul>
                    ) : null}
                    {/* <li
                      onClick={() => {
                        chnagviwe();
                      }}
                      className="changeViweToggle"
                    >
                      <label>Change View </label>
                      <img src={downarrow} alt="" />
                    </li> */}
                    <li onClick={toggleMenu} className="changeViewToggle">
                      <label>Change View</label>
                      <img src={downarrow} alt="" />
                    </li>
                    {innermenu2 == true ? (
                      <ul className="dropdownmenulist option-btns">
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio5"
                            className="form-check-input"
                            name="radio-group"
                            onChange={() => getDateRange("Daily")}
                          />
                          <label for="radio5" className="form-check-label">
                            Daily
                          </label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio6"
                            name="radio-group"
                            onChange={() => getDateRange("Weekly")}
                          />
                          {/* <img src="" alt="" /> */}
                          <label for="radio6">Weekly</label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio7"
                            name="radio-group"
                            onChange={() => getDateRange("Quarterly")}
                          />
                          <label for="radio7">Quaterly</label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio8"
                            name="radio-group"
                            onChange={() => getDateRange("Semi-Annually")}
                          />
                          <label for="radio8">Semi-Annually</label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio9"
                            name="radio-group"
                            onChange={() => getDateRange("Annually")}
                          />
                          <label for="radio9">Annually</label>
                        </li>
                      </ul>
                    ) : null}
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {reportPayLoad ? (
            <div className="table-wrapper">
              {loading ? (
                <div>
                  <div className="center-spinner">
                    <BeatLoader color="#3DA298" className="spinner" />
                  </div>
                </div>
              ) : purchaseReport && purchaseReport.length > 0 ? (
                <table>
                  <tr className="firstTabelRow">
                    <th>Sr. no</th>
                    <th>Date</th>
                    <th>Particular</th>
                    <th>Invoice Type</th>
                    <th>Invoice No.</th>
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>E-way Bill</th>
                    )}

                    <th>Basic Amt.</th>
                    {appSettings && appSettings.isGSTApplicable && <th>CGST</th>}
                    {appSettings && appSettings.isGSTApplicable && <th>SGST</th>}
                    {appSettings && appSettings.isGSTApplicable && <th>IGST</th>}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>Amount (Inc. GST)</th>
                    )}

                    <th>Gross Total</th>
                    <th>Other Charges</th>
                    <th>Action</th>
                  </tr>

                  {searchValue === "" ? displayInvoices : displayInvoicesSearch}
                </table>
              ) : (
                <NoDataFound />
              )}
            </div>
          ) : (
            ""
          )}

          <div className="col-lg-12 mt-2">
            {!loading &&
              Math.ceil(searchedDataPageCounts?.length / usersPerPage) > 1 && (
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  pageCount={
                    searchValue === ""
                      ? pageCount
                      : Math.ceil(searchedDataPageCounts?.length / usersPerPage)
                  }
                  onPageChange={changePage}
                  containerClassName={"paginationBttns"}
                  previousLinkClassName={"previousBttn"}
                  nextLinkClassName={"nextBttn"}
                  disabledClassName={"paginationDisabled"}
                  activeClassName={"paginationActive"}
                  forcePage={currentPage}
                />
              )}
          </div>

          {/* <div className="pagination">
                <div className="pagination_btn">
                  <button>&lt;&lt;</button>
                  <button className="backgroundPagination">1</button>
                  <button>2</button>
                  <button>3</button>
                  <button>4</button>
                  <button>&gt;&gt;</button>
                </div>
              </div> */}
        </div>
      </div>

      {/* salary mode */}

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="salary_model_main modal-lg"
      >
        <Modal.Header className="salary_model_header">
          <Modal.Title>Salary Details</Modal.Title>
          <div className="crossArrow">
            <img
              src={Dark === "darkMode" ? LightCross : DarkCross}
              alt=""
              onClick={handleClose}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="model_contain">
            <div className="overflowslarytable">
              <table className="model_tabel">
                <tr>
                  <td>Name Of Employee</td>
                  <td>Employee ID</td>
                  <td>Monthly Salary</td>
                </tr>
                <tr>
                  <th>Rohan Sharma</th>
                  <th>123456</th>
                  <th>Rs. 20,000</th>
                </tr>
                <tr>
                  <td>Payment Mode</td>
                  <td>- </td>
                  <td>- </td>
                </tr>
                <tr>
                  <th>Cash / Cheque / Online</th>
                  <th>- </th>
                  <th>- </th>
                </tr>
              </table>
            </div>
            <div className="salary_datatabel">
              <table>
                <tr>
                  <td rowspan="2">Month</td>
                  <td rowspan="2">No. of Days Present</td>
                  <td rowspan="2">Gross Salary</td>
                  <td colSpan="4">Deduction</td>
                  <td>Salary Payable </td>
                </tr>
                <tr>
                  <td>Profession Tax</td>
                  <td>Income Tax</td>
                  <td>Advance</td>
                  <td>ESIC</td>
                  <td></td>
                </tr>
                <tr>
                  <td>July</td>
                  <td>30</td>
                  <td>Rs. 20,000</td>
                  <td>Rs. 200</td>
                  <td>Rs. 200</td>
                  <td>Rs. 200</td>
                  <td>Rs. 200</td>
                  <td>Rs. 18,900</td>
                </tr>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*  By Date PopUp */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter "
        centered
        show={date}
        className="create-workflow-main date_model_salesReport"
      >
        <Modal.Header
          closeButton
          className=" create-workflow-topbody"
          onClick={dateclose}
        >
          <Modal.Title>
            <label
              htmlFor=""
              className="create-workflow-text dtaemodel_headimg colorlightmode"
            >
              Date
            </label>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row datemodel">
            <div className="col-lg-6">
              <label>From</label>
              <input
                type="date"
                onChange={(e) => setFromDate(e.target.value)}
                className="colorlightmodeinput"
              />
            </div>
            <div className="col-lg-6">
              <label>To</label>
              <input
                type="date"
                onChange={(e) => setToDate(e.target.value)}
                className="colorlightmodeinput"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="colorButtonLight">
          <div>
            <button className="modal-cancel-btn" onClick={dateclose}>
              Cancel
            </button>
            <button
              className="modal-create-btn"
              onClick={() => {
                setReportPayLoad({
                  ...reportPayLoad,
                  fromDate: fromDate,
                  toDate: toDate,
                });
                setDate(false);
              }}
            >
              Apply Filter
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Company modal popup */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter "
        centered
        show={company}
        className="create-workflow-main date_model_salesReport"
      >
        <Modal.Header
          className=" create-workflow-topbody"
          onClick={companyClose}
        >
          <Modal.Title>
            <label
              htmlFor=""
              className="create-workflow-text dtaemodel_headimg-2 colorlightmode"
            >
              Company
            </label>
          </Modal.Title>
          <div className="crossArrow">
            <img
              src={Dark === "darkMode" ? LightCross : DarkCross}
              alt=""
              onClick={handleClose}
            />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="companyModelMain ">
              <p>From</p>
              <select
                className="form-select select-drop-icon componymodelDrop2"
                aria-label="Default select example"
              >
                <option selected>Enter Company Name</option>
                <option value="1">20</option>
                <option value="2">10</option>
                <option value="3">5</option>
              </select>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="colorButtonLight">
          <div>
            <button className="modal-cancel-btn" onClick={companyClose}>
              Cancel
            </button>
            <button className="modal-create-btn">Apply Filter</button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* viwe details modal */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter "
        centered
        show={option}
        className="create-workflow-main incoive_details_model_main modal-xl"
      >
        <Modal.Header
          closeButton
          className=" create-workflow-topbody"
          onClick={optionshow}
        >
          <Modal.Title>
            <label
              htmlFor=""
              className="create-workflow-text dtaemodel_headimg"
            >
              Invoice Details
            </label>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row invoice_upper_section">
            <div className="col-lg-4 invoice_Upper_tabal">
              <label>Invoice NO</label>
              <h3>ABCD1234</h3>
            </div>
            <div className="col-lg-4 invoice_Upper_tabal">
              <label>Invoice Type.</label>
              <h3>
                Sales <span>Cash</span>
              </h3>
            </div>
            <div className="col-lg-4 invoice_Upper_tabal">
              <label>Date </label>
              <h3>06-06-2022</h3>
            </div>
            <div className="col-lg-4 invoice_Upper_tabal">
              <label>Name Of Customer/Party </label>
              <h3>Redbytes Software. Pvt. Ltd</h3>
            </div>
            <div className="col-lg-4 invoice_Upper_tabal">
              <label>Current Invoice</label>
              <h3>Rs.24,00,000.00</h3>
            </div>
            <div className="col-lg-4 invoice_Upper_tabal">
              <label>Invoice Amount</label>
              <h3>Rs.24,00,000.00</h3>
            </div>
          </div>

          <div className="invoice_tabel">
            <table>
              <tr>
                <td>Particular</td>
                <td>Address</td>
                <td>E-way Bill</td>
                <td>Sales Export Amt.</td>
                <td>Sales Indigenous</td>
                <td>CGST</td>
                <td>SGST</td>
              </tr>
              <tr>
                <td>Accounting and Bookeeping Service</td>
                <td>
                  125/2, Sainiketan Colony, kalas Road, Visharant Wadi, Pune,
                  Maharashtra 411015
                </td>
                <td>1111 2222 3333</td>
                <td>Rs. 24,00,000.00</td>
                <td>XYZ</td>
                <td>Rs.900.00</td>
                <td>Rs.900.00</td>
              </tr>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <ServiceinvoiceView
        previewTaxInvoiceData={previewTaxInvoiceData}
        previewLoader={previewLoader}
        isView={isView}
        setIsView={setIsView}
      />

      <ServicePrintPreview
        previewTaxInvoiceData={previewTaxInvoiceData}
        printModal={printModal}
        setPrintModal={setPrintModal}
        print={print}
        setPrint={setPrint}
      />
    </div>
  );
};

export default PurchaseReport;
